import { UNAVAILABLE_DATA_DISPLAY } from '../constants';

export const convertToYesNo = (value) => {
  const map = {
    Y: 'Yes',
    N: 'No',
  };
  return map[value] || UNAVAILABLE_DATA_DISPLAY;
};
